/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalRecuperarSenhaAliases {
  AVATAR_0 = 'avatar-0',
  BUTTON_CONFIRMAR = 'button-confirmar',
  DATE_FIELD_0 = 'date-field-0',
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FORM = 'form',
  INPUT_0 = 'input-0',
  LAYOUT_0 = 'layout-0',
  MODAL_RECUPERAR_SENHA = 'modal-recuperar-senha',
  PANEL_1 = 'panel-1',
  PANEL_AVISO = 'panel-aviso',
  PANEL_FORM = 'panel-form',
  RECAPTCHA_0 = 'recaptcha-0',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { ModalRecuperarSenhaAliases };
